<template>
  <div class="icon-service-dev">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 130 130"
      xmlns="http://www.w3.org/2000/svg"
    >

      <g
        transform="translate(-757 -34)"
        stroke="#FFF"
        stroke-width="2"
        fill="none"
        fill-rule="evenodd"
      >

        <ellipse
          cx="822"
          cy="98"
          rx="55"
          ry="55"
          stroke-dasharray="345.02 345.02"
          stroke-dashoffset="345.02"
        />
        <!-- eslint-disable max-len -->

        <path
          d="M832.036 69L812 127.143M838.627 121.282l22.655-22.655-22.655-22.6M804.654 121.282L782 98.627l22.654-22.6"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="189.57 189.57"
          stroke-dashoffset="189.57"
        />
        <!-- eslint-enable max-len -->
      </g>

    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconServiceDev'
};
</script>

<style lang="scss" src="@/assets/icons/icon-service-dev-view.scss"></style>



// WEBPACK FOOTER //
// icon-service-dev-view.vue